import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../../constants/common'
import { stopPropagation } from '../../../../../utils/events'
import { IconWithTooltip } from '../../../../Icon'
import { WidgetHeaderContentActionsExpandButton } from '../../../../Widget'

import {
  getRequestProfileWidgetDwellersAndLandlordsVisibilityTooltipKey,
  getRequestProfileWidgetDwellersAndLandlordsVisibilityType,
  isRequestProfileWidgetDwellersAndLandlordsVisibilityVisible,
} from './RequestProfileWidgetDwellersAndLandlordsHeaderActions.utils'

import * as styles from './RequestProfileWidgetDwellersAndLandlordsHeaderActions.module.css'

import ClosedEye from '../../../../../icons/closed-eye.svg'
import OpenEye from '../../../../../icons/open-eye.svg'

function RequestProfileWidgetDwellersAndLandlordsHeaderActions({
  className = styles.RequestProfileWidgetDwellersAndLandlordsHeaderActions,
  isVisibleToDwellers,
}) {
  const { t } = useTranslation()

  function handleVisibilityClick(event) {
    stopPropagation(event)
  }

  const visibilityType =
    getRequestProfileWidgetDwellersAndLandlordsVisibilityType(
      isVisibleToDwellers
    )

  return (
    <div className={className}>
      <div
        className={styles.visibilityStatusContainer}
        onClick={handleVisibilityClick}
      >
        <IconWithTooltip
          Icon={
            isRequestProfileWidgetDwellersAndLandlordsVisibilityVisible(
              visibilityType
            )
              ? OpenEye
              : ClosedEye
          }
          tooltip={t(
            getRequestProfileWidgetDwellersAndLandlordsVisibilityTooltipKey(
              visibilityType
            )
          )}
          tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
        />
      </div>
      <WidgetHeaderContentActionsExpandButton />
    </div>
  )
}

export default RequestProfileWidgetDwellersAndLandlordsHeaderActions
